import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import './index.css';
import App from './App';
import ErrorPage from "./ErrorPage";

import reportWebVitals from './reportWebVitals';

import AppDetails from './apps/AppDetails';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
  },
  {
    path: "facebook",
    element: <AppDetails
    name="Facebook"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/2e690e38-5ea2-463e-a57c-1e5aad5956d9/page/rcnGD"
     />,
  },
  {
    path: "instagram",
    element: <AppDetails
    name="Instagram"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/d5a958de-5987-4a70-9d8b-5d1f1c5266d0/page/rcnGD"
     />,
  },
  {
    path: "twitter",
    element: <AppDetails
    name="Twitter"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/29b37500-9730-4e34-a39a-4fc58aa75387/page/rcnGD"
     />,
  },
  {
    path: "snapchat",
    element: <AppDetails
    name="Snapchat"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/4762f4ff-2acb-47e9-9720-a756bf36f16f/page/rcnGD"
     />,
  },
  {
    path: "tiktok",
    element: <AppDetails
    name="TikTok"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/7da63b39-19d3-499b-a80e-76610f569512/page/rcnGD"
     />,
  },
  {
    path: "reddit",
    element: <AppDetails
    name="Reddit"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/5ee202c5-fa0c-49b1-9c8a-57a79fb10504/page/rcnGD"
     />,
  },
  {
    path: "linkedin",
    element: <AppDetails
    name="LinkedIn"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/a27bed4a-2d2b-4c4a-90f0-29e87b940498/page/rcnGD"
     />,
  },
  {
    path: "whatsapp",
    element: <AppDetails
    name="WhatsApp"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/e873ec53-7a27-4b9a-a97f-b3c1eb4e8333/page/rcnGD"
     />,
  },
  {
    path: "uber",
    element: <AppDetails
    name="Uber"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/00f97dbc-a5c9-47a7-bd0b-f3a20b93f3c0/page/rcnGD"
     />,
  },
  {
    path: "ubereats",
    element: <AppDetails
    name="Uber Eats"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/d9f1fa6a-39cd-41ad-818a-1d964d6b4326/page/rcnGD"
     />,
  },
  {
    path: "amazon",
    element: <AppDetails
    name="Amazon"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/c9b189a6-33c6-4568-b069-e33bda071630/page/rcnGD"
     />,
  },
  {
    path: "lyft",
    element: <AppDetails
    name="Lyft"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/6b5f3aad-e5e1-4048-addf-1b4acd7e5c6b/page/rcnGD"
     />,
  },
  {
    path: "doordash",
    element: <AppDetails
    name="DoorDash"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/654eaa4d-8885-46a1-bd7b-5bc7043e7dce/page/rcnGD"
     />,
  },
  {
    path: "gojek",
    element: <AppDetails
    name="Gojek"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/abfc2f6e-0907-4ae1-92e9-a8df140fbc1a/page/rcnGD"
     />,
  },
  {
    path: "grab",
    element: <AppDetails
    name="Grab"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/ea86f121-a064-4b2e-9866-120cf1fcd3b5/page/rcnGD"
     />,
  },
  {
    path: "wolt",
    element: <AppDetails
    name="Wolt"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/0a883d22-d98a-4bf9-b5df-93c7c4b37fcc/page/rcnGD"
     />,
  },
  {
    path: "instacart",
    element: <AppDetails
    name="Instacart"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/19017e52-cbe4-41ce-9508-b825fd74def7/page/rcnGD"
     />,
  },
  {
    path: "netflix",
    element: <AppDetails
    name="Netflix"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/711ee315-90f5-4ee7-bf64-2ceb908d41ad/page/rcnGD"
     />,
  },
  {
    path: "spotify",
    element: <AppDetails
    name="Spotify"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/99d2620e-cda7-46de-bd02-85ee0e4d2e85/page/rcnGD"
     />,
  },
  {
    path: "amazonprime",
    element: <AppDetails
    name="Amazon Prime"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/b99c7a56-97ba-418f-92e3-d1357c3aec4f/page/rcnGD"
     />,
  },
  {
    path: "soundcloud",
    element: <AppDetails
    name="Soundcloud"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/ed1ba680-c89f-4e6d-865c-0c2100cc1f84/page/rcnGD"
     />,
  },
  {
    path: "youtube",
    element: <AppDetails
    name="YouTube"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/079793cf-6add-4df4-9cf1-4fed058356b2/page/rcnGD"
     />,
  },
  {
    path: "gmail",
    element: <AppDetails
    name="Gmail"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/1c4c1a11-cda0-4590-8db9-4b8b8203e5c8/page/rcnGD"
     />,
  },
  {
    path: "googlemaps",
    element: <AppDetails
    name="Google Maps"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/79bff0b7-a9f1-4e77-b712-5e1339a1ff31/page/rcnGD"
     />,
  },
  {
    path: "duckduckgo",
    element: <AppDetails
    name="DuckDuckGo"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/2ae30f6b-bd96-418e-89b5-db48ec0e04fd/page/rcnGD"
     />,
  },
  {
    path: "firefox",
    element: <AppDetails
    name="Firefox"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/936df0a3-b58c-4f8a-a7d4-0095601360cd/page/rcnGD"
     />,
  },
  {
    path: "telegram",
    element: <AppDetails
    name="Telegram"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/9048d3e5-a06e-47a6-9d44-5d966c7953ef/page/rcnGD"
     />,
  },
  {
    path: "tinder",
    element: <AppDetails
    name="Tinder"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/f9719598-b410-4079-9fbc-ab87b9940ef3/page/rcnGD"
     />,
  },
  {
    path: "bumble",
    element: <AppDetails
    name="Bumble"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/1549db51-574a-405a-a109-8ce1c04b9bb1/page/rcnGD"
     />,
  },
  {
    path: "cred",
    element: <AppDetails
    name="Cred"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/f5d010c0-48e4-4b2c-a473-26f74a6cece4/page/rcnGD"
     />,
  },
  {
    path: "hotstar",
    element: <AppDetails
    name="Hotstar"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/aa60af21-53d8-4ba8-878a-ab1bd5a55c1d/page/rcnGD"
     />,
  },
  {
    path: "flipkart",
    element: <AppDetails
    name="Flipkart"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/acf05152-f622-4a2d-b250-33451d96b925/page/rcnGD"
     />,
  },
  {
    path: "phonepe",
    element: <AppDetails
    name="PhonePe"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/5f391248-39fa-4025-bd22-359d468491f0/page/rcnGD"
     />,
  },
  {
    path: "paytm",
    element: <AppDetails
    name="Paytm"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/3a793bfc-2d73-4468-9c04-d17d8f7760ec/page/rcnGD"
     />,
  },
  {
    path: "meesho",
    element: <AppDetails
    name="Meesho"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/90120dc6-2d54-4454-b0be-6f4fcd953985/page/rcnGD"
     />,
  },
  {
    path: "sharechat",
    element: <AppDetails
    name="ShareChat"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/b711cda6-23ac-4750-9e23-73edf1965cb5/page/rcnGD"
     />,
  },
  {
    path: "microsoftteams",
    element: <AppDetails
    name="Microsoft Teams"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/cb0fa5a6-4c09-4e93-bed3-0610832d321b/page/rcnGD"
     />,
  },
  {
    path: "microsoftoffice",
    element: <AppDetails
    name="Microsoft Office"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/5ef88bf1-4a87-4c72-a3ce-820820c3afc5/page/rcnGD"
     />,
  },
  {
    path: "microsoftexcel",
    element: <AppDetails
    name="Microsoft Excel"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/877fb71d-4ff9-4dfc-b7d9-0f26377c5da2/page/rcnGD"
     />,
  },
  {
    path: "microsoftpowerpoint",
    element: <AppDetails
    name="Microsoft PowerPoint"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/e607f536-62e9-4308-9230-7453d6b21d8c/page/rcnGD"
     />,
  },
  {
    path: "microsoftoutlook",
    element: <AppDetails
    name="Microsoft Outlook"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/aafb7529-a733-43a6-a925-070ad31eb1fa/page/rcnGD"
     />,
  },
  {
    path: "airbnb",
    element: <AppDetails
    name="Airbnb"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/3474e774-ff61-4af6-adf0-4dbeb354db30/page/rcnGD"
     />,
  },
  {
    path: "github",
    element: <AppDetails
    name="GitHub"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/1600abbc-40de-437e-8bab-0c55d5917e48/page/rcnGD"
     />,
  },
  {
    path: "truecaller",
    element: <AppDetails
    name="Truecaller"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/e819f14e-3dd6-4299-ab9f-934c900761ed/page/rcnGD"
     />,
  },
  {
    path: "booking",
    element: <AppDetails
    name="Booking"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/b09af245-6536-4e17-8b58-362e98baf520/page/rcnGD"
     />,
  },
  {
    path: "dropbox",
    element: <AppDetails
    name="Dropbox"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/1723e46b-6502-4461-bf5e-5a9e56d6a846/page/rcnGD"
     />,
  },
  {
    path: "cashapp",
    element: <AppDetails
    name="Cash App"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/63137cc9-7856-4bbf-becb-7ae42182f585/page/rcnGD"
     />,
  },
  {
    path: "slack",
    element: <AppDetails
    name="Slack"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/bfa689b8-eed4-4c15-8ae5-eb9ca0a0584e/page/rcnGD"
     />,
  },
  {
    path: "fitbit",
    element: <AppDetails
    name="Fitbit"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/311cbb6d-7360-420a-931a-6a06eebc4ac7/page/rcnGD"
     />,
  },
  {
    path: "buffer",
    element: <AppDetails
    name="Buffer"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/fec14fd8-d3a8-461b-a5ef-9987a4e25347/page/rcnGD"
     />,
  },
  {
    path: "todoist",
    element: <AppDetails
    name="Todoist"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/5641a775-4f09-4599-9ee8-7f6077dc7f6d/page/rcnGD"
     />,
  },
  {
    path: "strava",
    element: <AppDetails
    name="Strava"
    dashboardLink="https://lookerstudio.google.com/embed/reporting/91d37373-d737-4370-bf6f-695af8411e07/page/rcnGD"
     />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
